module.exports = __webpack_public_path__ + "img/get_redbag.44488c4a.png";